import type { ActivationObjectSchema } from "app/pages/activation/types/api";

export type OnCreation = {
    onSuccess?: (data: ActivationObjectSchema) => void;
    onError?: (error: Error) => void;
    onSettled?: () => void;
};
export type DomainFromAutoselect = { name: string; icon: string };

export enum ProjectErrors {
    Name = "Name",
    SameCompetitors = "SameCompetitors",
}

export type CreationErrors = {
    [ProjectErrors.Name]: string | null;
    [ProjectErrors.SameCompetitors]: boolean;
};
